export default {
  componentName: 'basstrakk-leaderboard',
  exampleImgUrl:
    'https://drive.google.com/open?id=1lIR3U4UNzF2CTLSItLzjYu5TI2_SGZYL',
  nickname: 'basstrakk-leaderboard',
  pageList: [
    'https://www.bassmaster.com/basstrakk/tournaments/2018-toyota-bassmaster-angler-year-championship',
  ],
  renderId: 'react-app--basstrakk-leaderboard',
};
